"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useDeepMemo_1 = require("./useDeepMemo");
var standard_1 = require("../standard");
function useBaseQuery(requestConfig, hookConfig, lazy) {
    var _a = react_1.default.useState(), data = _a[0], setData = _a[1];
    var _b = react_1.default.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = react_1.default.useState(), error = _c[0], setError = _c[1];
    var _d = react_1.default.useState(false), runLazy = _d[0], setRunLazy = _d[1];
    var memoKey = useDeepMemo_1.useDeepMemoKey({
        requestConfig: requestConfig,
        skip: hookConfig === null || hookConfig === void 0 ? void 0 : hookConfig.skip,
        runLazy: runLazy,
    });
    /* eslint-disable react-hooks/exhaustive-deps */
    var fetcher = react_1.default.useCallback(function () {
        setLoading(true);
        return standard_1.httpRequest(memoKey.requestConfig)
            .then(function (retData) {
            setLoading(false);
            setData(retData);
            if (hookConfig === null || hookConfig === void 0 ? void 0 : hookConfig.onCompleted) {
                hookConfig.onCompleted(retData);
            }
        })
            .catch(function (err) {
            setLoading(false);
            setError(err);
            if (hookConfig === null || hookConfig === void 0 ? void 0 : hookConfig.onError) {
                hookConfig.onError(err);
            }
        });
    }, [memoKey]);
    /* eslint-enable react-hooks/exhaustive-deps */
    react_1.default.useEffect(function () {
        if (lazy) {
            if (memoKey.runLazy) {
                fetcher();
            }
        }
        else if (!memoKey.skip) {
            fetcher();
        }
    }, [memoKey, fetcher, lazy]);
    var retData = { data: data, error: error, loading: loading, refetch: fetcher };
    return lazy ? [function () { return setRunLazy(true); }, retData] : retData;
}
exports.default = useBaseQuery;
//# sourceMappingURL=useBaseQuery.js.map